import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { camelizeKeys } from '~/redux/api/transformers/utils';
import { testIsAxiosError } from '~/redux/api/utils';
import { everest } from '~/services/serviceInstances';

import { Supplier, SupplierListResponse } from './types';

interface GetIntegrateWorkflowSuppliersParams {
  workflowId: string;
  searchString?: string;
}

export const getIntegrateWorkflowSuppliers = async ({
  workflowId,
  searchString,
}: GetIntegrateWorkflowSuppliersParams): Promise<Supplier[]> => {
  try {
    const params = searchString ? `?q=${encodeURIComponent(searchString)}` : '';
    const response: SupplierListResponse = await everest.get(
      `/integrate-workflow/${workflowId}/suppliers${params}`,
    );

    return response.data.map((supplier) => ({
      ...camelizeKeys(supplier.attributes),
      id: supplier.id,
    }));
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors?.[0];
      if (errorResponse) {
        throw createCodedError({
          message: errorResponse.detail ?? errorResponse.title,
          statusCode: errorResponse.status,
          title: errorResponse.title,
        });
      }
    }

    throw error;
  }
};
